"use strict";

CompanyGdprContactEditCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  'CompanyGdprContactsService',
  '$translate',
  'gdprContact',
  'growl'];

function CompanyGdprContactEditCtrl(
  $scope,
  $stateParams,
  $state,
  CompanyGdprContactsService,
  $translate,
  gdprContact,
  growl) {
  $scope.gdprContact = gdprContact;

  $scope.save = function(gdprContact) {
    CompanyGdprContactsService.update({companyId: $stateParams.companyId, contactId: $stateParams.contactId}, gdprContact, function() {
      growl.addSuccessMessage($translate.instant('gdpr.contact.save-success'));
      $state.go('root.company.account.gdpr-contacts.list');
    }, function(){
      growl.addErrorMessage($translate.instant('gdpr.contact.save-failure'));
    });
  };

}

CompanyGdprContactEditCtrl.resolve = {
  gdprContact: ['$stateParams', 'CompanyGdprContactsService', function($stateParams, CompanyGdprContactsService) {
    return CompanyGdprContactsService.get({companyId: $stateParams.companyId, contactId: $stateParams.contactId}).$promise;
  }]
};

module.exports  = CompanyGdprContactEditCtrl;

angular.module("dokiv")
  .controller("CompanyGdprContactEditCtrl", CompanyGdprContactEditCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/gdpr/contacts/CompanyGdprContactEditCtrl.js
// module id = 355
// module chunks = 0